import Fab from '@mui/material/Fab';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

const CHAT_URL = 'https://gomixapp.co.il/#chat';

const BRAND_GRADIENT = 'linear-gradient(135deg, #CC4279 0%, #B8275F 100%)';

const FAB_SHADOW =
  '0 10px 24px -6px rgba(184, 39, 95, 0.45), 0 4px 10px -3px rgba(37, 16, 68, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.18)';
const FAB_SHADOW_HOVER =
  '0 16px 32px -6px rgba(184, 39, 95, 0.5), 0 6px 14px -3px rgba(37, 16, 68, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.22)';
const FAB_SHADOW_FOCUS =
  '0 0 0 3px rgba(203, 173, 255, 0.6), 0 10px 24px -6px rgba(184, 39, 95, 0.45), 0 4px 10px -3px rgba(37, 16, 68, 0.35)';

export function ChatFab() {
  const { t } = useTranslate();

  return (
    <Fab
      component="a"
      href={CHAT_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('Chat with us')}
      sx={(theme) => ({
        position: 'fixed',
        right: { xs: 16, md: 24 },
        bottom: { xs: 16, md: 24 },
        zIndex: theme.zIndex.speedDial,
        width: 56,
        height: 56,
        color: '#FFF6FB',
        background: BRAND_GRADIENT,
        boxShadow: FAB_SHADOW,
        transition: theme.transitions.create(['transform', 'box-shadow'], {
          duration: 240,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        }),
        '&:hover': {
          background: BRAND_GRADIENT,
          transform: 'translateY(-3px) scale(1.04)',
          boxShadow: FAB_SHADOW_HOVER,
        },
        '&:active': { transform: 'translateY(-1px) scale(0.98)' },
        '&:focus-visible': { boxShadow: FAB_SHADOW_FOCUS },
        '@media (prefers-reduced-motion: reduce)': {
          transition: 'none',
          '&:hover': { transform: 'none' },
        },
      })}
    >
      <Iconify width={26} icon="solar:chat-round-dots-bold" />
    </Fab>
  );
}
